import { AlertCircleIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { cn } from '@/lib/utils'

interface AgencyRejectionAlertProps {
  rejectionReason: string
  className?: string
}

/**
 * Displays the rejection reason when an agency's marketplace submission was rejected.
 */
export const AgencyRejectionAlert = ({
  rejectionReason,
  className,
}: AgencyRejectionAlertProps): ReactNode => (
  <Alert variant="destructive" className={cn('agency-rejection-alert', className)}>
    <AlertCircleIcon className="size-4" />
    <AlertTitle>Submission Rejected</AlertTitle>
    <AlertDescription>{rejectionReason}</AlertDescription>
  </Alert>
)

AgencyRejectionAlert.displayName = 'AgencyRejectionAlert'
